import React from "react";

const BS5_SelectMenus = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_SelectMenus Component</h2>
      <p>This is the BS5_SelectMenus component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_SelectMenus;
